//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { HEADER, MOBILE, TABLET } from '@/scripts/constants/media-query'
import { ACTION_HIDE_ACCOUNT_BULLET } from '@/scripts/store/header/actions'
import { createNamespacedHelpers, mapGetters } from 'vuex'
import { NAV_BAG, NAV_MYACCOUNT, NAV_SEARCH } from '@/scripts/constants/tracker'

const { mapGetters: mapGettersHeader, mapActions: mapActionsHeader } =
  createNamespacedHelpers('header')

export default {
  name: 'rb-header-actions',
  props: {
    isAPanelOpen: { type: Boolean, default: false },
    isAccountPanelOpen: { type: Boolean, default: false },
    isNoEcommerce: { type: Boolean, default: false },
    promoBulletIsVisible: { type: Boolean, default: false },
  },
  data: function () {
    return {
      NAV_BAG,
      NAV_MYACCOUNT,
      NAV_SEARCH,
    }
  },
  computed: {
    ...mapGetters(['userLoggedIn', 'userName', 'cartQuantity']),
    ...mapGettersHeader(['currentMenuId', 'accountBulletIsVisible']),
    isMobile() {
      return this.$mq === MOBILE || this.$mq === TABLET || this.$mq === HEADER
    },
    isUserLoggedIn() {
      return this.userLoggedIn
    },
    formattedCartItemsLength() {
      return this.cartQuantity > 99 ? '99+' : this.cartQuantity
    },
    tabIndex() {
      if (this.currentMenuId) return '-1'
      return '0'
    },
  },
  methods: {
    ...mapActionsHeader({
      hideAccountBullet: ACTION_HIDE_ACCOUNT_BULLET,
    }),
    emitSearchClick() {
      this.$emit('searchClicked')
    },
    emitAccountClick() {
      this.hideAccountBullet()
      this.$emit('accountClicked')
    },
    emitOpenClick() {
      this.$emit('openClicked')
    },
    emitCloseClick() {
      this.$emit('closeClicked')
    },
    emitCartClick() {
      this.$emit('cartClicked')
    },
  },
}
